import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.ActivitySection', {
    headerText: 'AUDIT TRAIL',
    expandButtonText: '{count, plural, one {Show # event} other {Show # events}}',
});
